// Registration link expiry check: true once more than 7 days (168 hours) have elapsed since
// requestTime. Frontend-only enforcement - no backend endpoint validates link freshness.
export function isExpired (requestTime, now) {
  const diffHours = Math.abs(Math.floor((now.getTime() - new Date(requestTime).getTime()) / 1000 / 3600))
  return diffHours >= 7 * 24
}
